import styled from "styled-components";
import { Icon } from "@ebscois/react-component-library";

export const StyledNavItem = styled.span`
  & sup {
    font-size: ${(props) => props.theme.font.size.xs};
    vertical-align: super;
  }
`;

export const StyledIcon = styled(Icon)`
  margin-left: ${(props) => props.theme.space.xs};
  vertical-align: text-bottom;
`;
